import { Divider } from 'antd';
import { Icon } from '../../icon/icon';
import ButtonSecondaryMedium from '../ButtonSecondary/ButtonSecondaryMedium';
import { openModal } from './openModal';

const openModalFitHeight = ({ func }) => {
  const result = openModal({
    title: (
      <div className="flex items-start justify-start gap-12 self-stretch grow">
        <span className="flex w-32 h-32" style={{ color: '#258FD2' }}>
          <Icon.ICFillSpace />
        </span>
        <span className="text-title-medium emphasized">
          Tự động thay đổi chiều cao
        </span>
      </div>
    ),
    content: (
      <>
        <Divider type="horizontal" className={'m-0 !p-0'} />
        <div className="p-16 gap-8 flex items-center justify-start flex-col m-0">
          <span className="text-body-medium text-start">
            Thay đổi chiều cao tất cả <b>tủ bếp đụng trần</b> theo{' '}
            <b>tủ bếp trên</b> cao nhất hiện tại.
          </span>
        </div>
        <Divider type="horizontal" className={'m-0 !p-0'} />
      </>
    ),
    centered: true,
    width: 538,
    classNames: {
      header: '!px-16 !py-12 gap-12 !m-0',
      body: '!p-0 !m-0 self-stretch',
      iconClose: 'absolute top-12 right-16',
      footer: '!px-16 !py-12 !gap-16 !items-end !flex !justify-end !m-0',
    },
    footer: (
      <>
        <ButtonSecondaryMedium
          title={'Hủy bỏ'}
          onClick={() => {
            result.destroy();
          }}
        />
        <ButtonSecondaryMedium
          title={'Sử dụng'}
          onClick={() => {
            result.destroy();
            func?.();
          }}
        />
      </>
    ),
  });
  return result;
};

export default openModalFitHeight;
